import { messages } from '@qality/common-messages';
import { StorageOfUniqueServices } from '@qality/common-service';

import TestExecutionService from './TestExecutionService';

export default {
  async deleteTestExecution(
    testExecutionId: number,
    testCaseKey?: string
  ): Promise<void> {
    try {
      await TestExecutionService.deleteTestExecution(testExecutionId);
      if (testCaseKey) {
        const url = StorageOfUniqueServices.get(
          'URLService'
        ).getTestCaseExecutionHistoryUrl(testCaseKey, testCaseKey);
        StorageOfUniqueServices.get('AP').navigator.go('site', {
          absoluteUrl: url,
        });
      } else {
        window.location.reload();
      }
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        e,
        messages['error.deleteTestExecution.message']
      );
    }
  },
};
